import { combineReducers } from 'redux';
import login from './login';

export default combineReducers({
  login,
});
